import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faChevronDown, faChevronUp, faSpinner } from '@fortawesome/free-solid-svg-icons';
import MetricCard from './components/MetricCard.js';
import { getMaxHistoryLength } from '../shared/historyUtils.js';

class DemographicCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: this.props.category === 'Demographic' ? true : false
    };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    const { dataPointNames, currentDistrictsData, loading, historyWindow } = this.props;
    const { collapse } = this.state;

    const metrics = dataPointNames
      .filter((dp) => dp.category === 'Demographic' && currentDistrictsData[dp.name])
      .map((dp) => ({ name: dp.title || dp.name, yearData: currentDistrictsData[dp.name] }));

    return (
      <div className="data-section mb-3">
        <div className="data-section-header" onClick={this.toggle.bind(this)}>
          <div>
            <div className="data-section-title">
              <FontAwesomeIcon icon={faUsers} />
              Demographics
            </div>
            <div className="data-section-subtitle">Population structure, migration, workforce, and household composition.</div>
          </div>
          <div className="data-section-header-right">
            <span className="data-section-meta">{metrics.length} metrics · {getMaxHistoryLength(metrics)} years</span>
            <FontAwesomeIcon icon={collapse ? faChevronUp : faChevronDown} className="text-muted" />
          </div>
        </div>
        <Collapse isOpen={collapse}>
          {loading ? (
            <div className="text-center py-4">
              <FontAwesomeIcon icon={faSpinner} size="3x" spin className="text-primary" />
            </div>
          ) : metrics.length > 0 ? (
            <div className="metric-card-grid">
              {metrics.map((metric, i) => (
                <MetricCard key={i} name={metric.name} yearData={metric.yearData} historyWindow={historyWindow} />
              ))}
            </div>
          ) : (
            <p className="text-muted small p-3 mb-0">No data available.</p>
          )}
        </Collapse>
      </div>
    );
  }
}

export default DemographicCard;
